'use client';
function getSeriesLabels(series) {
  if (!series) {
    return {};
  }
  return series.reduce((acc, item) => {
    const matchFound = item.name.search(/\./);
    if (matchFound >= 0) {
      const key = item.name.substring(matchFound + 1);
      acc[key] = item.label;
      return acc;
    }
    acc[item.name] = item.label;
    return acc;
  }, {});
}

export { getSeriesLabels };
//# sourceMappingURL=get-series-labels.mjs.map
